export const getColumnHeaderWo = async (th) => {
  let get = await th.$api.get("api/v1/konf/searchcompany", {
    params: { search: "WO-HEADER-COLUMNS" },
  });
  return get.data;
};
